import { defineMessages } from 'react-intl'

export const networkWLANsMessages = defineMessages({
  wlansSSID: {
    id: 'networkWLANsMessages.wlansSSID',
    description: 'Title text for WLAN SSID',
    defaultMessage: 'SSID',
  },
  wlansAccessPoints: {
    id: 'networkWLANsMessages.wlansAccessPoints',
    description: 'Title text for WLAN Access Points',
    defaultMessage: 'Access Points',
  },
  wlansVLANId: {
    id: 'networkWLANsMessages.wlansVLANId',
    description: 'Title text for WLAN VLAN ID',
    defaultMessage: 'VLAN ID',
  },
  wlansBands: {
    id: 'networkWLANsMessages.wlansBands',
    description: 'Title text for WLAN Bands',
    defaultMessage: 'Bands',
  },
  wlansSecurity: {
    id: 'networkWLANsMessages.wlansSecurity',
    description: 'Title text for WLAN Security',
    defaultMessage: 'Security',
  },
  wlansGuest: {
    id: 'networkWLANsMessages.wlansGuest',
    description: 'Title text for WLAN Guest Enabled',
    defaultMessage: 'Guest Portal',
  },
  titleDelete: {
    id: 'networkWLANsMessages.titleDelete',
    description: 'Title text for WLAN Delete',
    defaultMessage: 'Delete WLAN',
  },
  titleDisable: {
    id: 'networkWLANsMessages.titleDisable',
    description: 'Title text for WLAN Disable',
    defaultMessage: 'Disable WLAN',
  },
  titleEnable: {
    id: 'networkWLANsMessages.titleEnable',
    description: 'Title text for WLAN Enabled',
    defaultMessage: 'Enable WLAN',
  },
  confirmDeleteMessage: {
    id: 'networkWLANsMessages.confirmDeleteMessage',
    description: 'Title text for WLAN Delete',
    defaultMessage: 'Yes, Delete',
  },
  confirmDisableMessage: {
    id: 'networkWLANsMessages.confirmDisableMessage',
    description: 'Title text for WLAN Disable',
    defaultMessage: 'Yes, Disable',
  },
  confirmEnableMessage: {
    id: 'networkWLANsMessages.confirmEnableMessage',
    description: 'Title text for WLAN Enabled',
    defaultMessage: 'Yes, Enable',
  },
  copyWLAN: {
    id: 'networkWLANsMessages.copyWLAN',
    description: 'Title text for Copy WLAN',
    defaultMessage: 'Copy WLAN',
  },
  titleDeleteTemplate: {
    id: 'networkWLANsMessages.titleDeleteTemplate',
    description: 'Title text for Template Delete',
    defaultMessage: 'Delete Template',
  },
})
